import { useAuth } from 'oidc-react';
import { createContext, useContext, useState, useEffect } from 'react';

type TenantCtx = {
  selectedTenantId: string | null;
  setSelectedTenantId: (id: string) => void;
};

const TenantContext = createContext<TenantCtx | null>(null);

export const TenantSelectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth = useAuth();

  // Initialize state from localStorage or auth profile
  const [selectedTenantId, setSelectedTenantIdState] = useState<string | null>(() => {
    return localStorage.getItem('id') || (auth?.userData?.profile?.tenant_id as string) || null;
  });

  // Wrapper to update state and localStorage together
  const setSelectedTenantId = (id: string) => {
    localStorage.setItem('id', id);
    setSelectedTenantIdState(id);
  };

  // Optional: sync with auth profile if localStorage is empty initially
  useEffect(() => {
    if (!selectedTenantId && auth?.userData?.profile?.tenant_id) {
      setSelectedTenantId(auth.userData.profile.tenant_id as string);
    }
  }, [auth?.userData?.profile?.tenant_id]);

  return <TenantContext.Provider value={{ selectedTenantId, setSelectedTenantId }}>{children}</TenantContext.Provider>;
};

export const useTenantSelection = () => {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error('useTenantSelection must be used inside TenantSelectionProvider');
  return ctx;
};
